import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { RetailProducts } from './RetailProducts'

const WrappedRetailProducts = withLayout(LayoutType.NoPadding, RetailProducts)

export { WrappedRetailProducts as RetailProducts }
